import axiosInstance from '../axiosInstance'

// Models
import { Site, SiteID, SiteJson, } from './models/site'
import { SiteConfig, SiteConfigJson } from './models/siteConfig'
import { SitePermission, SitePermissionJson } from './models/sitePermission'

export const show = async (siteId: SiteID): Promise<{ site: Site }> => {
    const response = await axiosInstance.get(`api/orgs/${siteId}`)

    const data = response.data.data as SiteJson

    return {
        site: Site.fromJson(data),
    }
}

export const showConfig = async (site: Site): Promise<{ siteConfig: SiteConfig }> => {
    const response = await axiosInstance.get(`api/orgs/${site.id}/config`)

    const data = response.data.data as SiteConfigJson

    return {
        siteConfig: SiteConfig.fromJson(data),
    }
}

export const showUserPermissions = async (site: Site): Promise<{ sitePermissions: SitePermission[] }> => {
    const response = await axiosInstance.get(`api/orgs/${site.id}/user/permissions`)

    const responseData = response.data.data as { name: string }[]
    const data = responseData.map((permission) => {
        const perm = permission.name.split(' ')

        return {
            ability: perm[0],
            subject: perm[1],
        }
    }) as SitePermissionJson[]

    return {
        sitePermissions: data.map((sitePermission) => {
            return SitePermission.fromJson(sitePermission)
        }),
    }
}

export const showCurrent = async (): Promise<{ site: Site }> => {
    const response = await axiosInstance.get('api/orgs/current')

    const data = response.data.data as SiteJson

    return {
        site: Site.fromJson(data),
    }
}
